<template>
    <section class="section-loading-list" :class="color" v-if="isShown()">
        <LayoutContained :class="padding ? padding : 'p-0'">
            <LoadingWidget v-if="isLoading()"></LoadingWidget>
            <div v-if="isNoResults()" class="font-light italic">
                <slot>No {{ thing || 'results' }} found.</slot>
            </div>
            <AlertError v-if="isError()" class="mt-3" :alert="error"></AlertError>
        </LayoutContained>
    </section>
</template>

<script>

export default {
    name: 'SectionLoadingList',

    props: ['thing', 'results', 'error', 'padding', 'color'],
    methods: {
        isShown: function () {
            return (this.isLoading() || this.isNoResults() || this.isError());
        },
        isLoading: function () {
            return this.results === null && !this.error;
        },
        isNoResults: function () {
            return this.results instanceof Array && this.results.length === 0;
        },
        isError: function () {
            return !!(this.error);
        }
    }
};
</script>
